export const mapping = { type: 'object' }
